import { createFileRoute } from "@tanstack/react-router";
import { CVBuilder } from "@/components/cv/CVBuilder";
import { PayFastR15CvButton } from "@/components/site/PayFastR15CvButton";
import { Disclaimer } from "@/components/site/Disclaimer";
import { FeatureErrorBoundary } from "@/components/site/FeatureErrorBoundary";


export const Route = createFileRoute("/cv-builder")({
  validateSearch: (s: Record<string, unknown>) => ({
    template: typeof s.template === "string" ? s.template : undefined,
  }),
  head: () => ({
    meta: [
      { title: "Free AI CV Builder — South Africa | Nkadimeng Danny" },
      {
        name: "description",
        content:
          "Build a professional, ATS-friendly CV in minutes with free AI. 20+ South African-ready templates, instant PDF download — no payment required.",
      },
      { property: "og:title", content: "Free AI CV Builder — Nkadimeng Danny" },
      {
        property: "og:description",
        content:
          "Generate a recruiter-ready CV tailored to your target role. Free, instant PDF, no payment.",
      },
      { property: "og:url", content: "https://nkadimengdannylcs.com/cv-builder" },
    ],
    links: [{ rel: "canonical", href: "https://nkadimengdannylcs.com/cv-builder" }],
  }),
  component: FreeCVBuilderPage,
});

function FreeCVBuilderPage() {
  const { template } = Route.useSearch();
  return (
    <div className="container-narrow py-10 space-y-6">
      <Disclaimer variant="compact" />
      <FeatureErrorBoundary
        featureName="CV Builder"
        context={{ template, publicMode: true, freeLimit: 2 }}
      >
        <CVBuilder
          publicMode
          freeLimit={2}
          presetTemplate={template}
          title="Free AI CV Builder"
          subhead={
            <p className="mt-1 text-sm text-foreground/70">
              Build a recruiter-ready, ATS-friendly CV in minutes — tailored to
              your target role and the South African market. Up to{" "}
              <strong>2 free AI generations</strong> per browser. Premium CVs from{" "}
              <strong>R15</strong> — priced by quality &amp; recruiter demand.
            </p>
          }
        />
      </FeatureErrorBoundary>

      <div className="mt-8 grid gap-6 md:grid-cols-[1fr_320px]">
        <div className="rounded-2xl border border-dashed border-border bg-secondary/30 p-5 text-sm text-muted-foreground">
          <p className="font-semibold text-navy">Quick buy — entry-level CV</p>
          <p className="mt-1">
            Need a simple, ready-to-use CV right now? Pay R15 via PayFast and
            we'll deliver an entry-level CV designed for retail, hospitality,
            customer service, general work or part-time roles.
          </p>
        </div>
        <PayFastR15CvButton />
      </div>
    </div>
  );
}
